// removed by extract-text-webpack-plugin
module.exports = {"toggle-label":"Toggle__toggle-label","toggleLabel":"Toggle__toggle-label","toggle-checkbox":"Toggle__toggle-checkbox","toggleCheckbox":"Toggle__toggle-checkbox","toggle-switch":"Toggle__toggle-switch","toggleSwitch":"Toggle__toggle-switch","toggle-handle":"Toggle__toggle-handle","toggleHandle":"Toggle__toggle-handle","toggle-msg-on":"Toggle__toggle-msg-on","toggleMsgOn":"Toggle__toggle-msg-on","toggle-msg-off":"Toggle__toggle-msg-off","toggleMsgOff":"Toggle__toggle-msg-off"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Toggle/Toggle.scss
// module id = 1828
// module chunks = 8